import { render } from "./withdrawalHistoryList.vue?vue&type=template&id=6e71570e&scoped=true"
import script from "./withdrawalHistoryList.vue?vue&type=script&lang=js"
export * from "./withdrawalHistoryList.vue?vue&type=script&lang=js"

import "./withdrawalHistoryList.vue?vue&type=style&index=0&id=6e71570e&scoped=true&lang=css"
import "./withdrawalHistoryList.vue?vue&type=style&index=1&id=6e71570e&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e71570e"]])

export default __exports__